import {
  set,
  firestoreDocumentById,
} from '../firebase/firestore';

export const removeReflectionDocument = async (analysisId, reflectionId) => {
  try {
    const doc = firestoreDocumentById(`reflections/${reflectionId}/reflectionDocuments`, analysisId);
    await doc.delete();
  } catch (e) {
    console.log('Error removeReflectionDocument', e);
    throw e;
  }
};

export const createReflectionDocument = async (analysisId, reflectionId) => {
  try {
    const payload = {
      id: analysisId,
      reflectionId,
      categories: ['general'],
      retentionStatus: { general: 'notRetained' },
      retentionElements: {},
    };

    const doc = firestoreDocumentById(`reflections/${reflectionId}/reflectionDocuments`, analysisId);
    await set(doc, payload);
  } catch (e) {
    console.log('Error createReflectionDocument', e);
    throw e;
  }
};
